// ---- components/About.js ----
export function About() {
  return (
    <section id="about" className="px-6 py-16 max-w-6xl mx-auto">
      <h2 className="text-3xl font-bold text-center mb-1">
        Seamless Integration & Custom Development
      </h2>
      <p className="text-lg text-gray-700 dark:text-gray-300">
        Ethos Tech Hub specializes in connecting your business systems for optimal performance. We seamlessly 
        integrate ERP systems with third-party applications, legacy systems, weigh bridges, and financial 
        institutions including M-Pesa, banks, and fintech platforms. Beyond integration, we develop custom 
        software solutions—mobile apps, web systems, and desktop applications—using cutting-edge technologies 
        and AI agents to solve your unique business challenges and drive digital transformation.
      </p>
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-sm">
        <div className="flex items-center p-3 bg-gray-50 rounded-lg">
          <span className="text-green-500 mr-3 text-lg">🔗</span>
          <span>ERP & Third-Party System Integration</span>
        </div>
        <div className="flex items-center p-3 bg-gray-50 rounded-lg">
          <span className="text-green-500 mr-3 text-lg">💰</span>
          <span>Financial Institution Integration</span>
        </div>
        <div className="flex items-center p-3 bg-gray-50 rounded-lg">
          <span className="text-green-500 mr-3 text-lg">⚖️</span>
          <span>Weigh Bridge & Hardware Integration</span>
        </div>
        <div className="flex items-center p-3 bg-gray-50 rounded-lg">
          <span className="text-green-500 mr-3 text-lg">📱</span>
          <span>Custom Mobile App Development</span>
        </div>
        <div className="flex items-center p-3 bg-gray-50 rounded-lg">
          <span className="text-green-500 mr-3 text-lg">🌐</span>
          <span>Web & Desktop Application Development</span>
        </div>
        <div className="flex items-center p-3 bg-gray-50 rounded-lg">
          <span className="text-green-500 mr-3 text-lg">🤖</span>
          <span>AI-Powered Solutions & Automation</span>
        </div>
      </div>
      
      {/* Additional Integration Capabilities */}
      <div className="mt-8 bg-blue-50 rounded-xl p-6">
        <h3 className="text-xl font-bold text-gray-800 mb-4">Our Integration Expertise Includes:</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
          <div>
            <h4 className="font-semibold text-gray-700 mb-2">Financial Systems</h4>
            <ul className="text-gray-600 space-y-1">
              <li>• M-Pesa & Mobile Money Integration</li>
              <li>• Bank API Integration</li>
              <li>• Fintech Platform Connections</li>
              <li>• Payment Gateway Integration</li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-gray-700 mb-2">Hardware & IoT</h4>
            <ul className="text-gray-600 space-y-1">
              <li>• Weigh Bridge Systems</li>
              <li>• Barcode Scanners & Printers</li>
              <li>• POS Systems</li>
              <li>• IoT Device Integration</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}